/** @format */

export const configDefault = {
    REFRESH_TOKEN_TIME_REQUEST_SECOND: 60,
    MNP_CASE_E06_WAITING_TIME_IN_SECONDS: 14400,
    TERMINATION_CONTRACT_PERIOD_IN_MONTH: 1,
    WITHRAWAL_AGREEMENT_MAX_DAYS_AFTER_ACTIVATION: 14,

    ES_API_PREFIX: 'es',
    PLATFORM_API_PREFIX: 'platform',

    LAST_STATUS_CHANGE_MIN_HOURS_TO_DISPLAY: 1,
    LAST_STATUS_CHANGE_MAX_HOURS_TO_DISPLAY: 300,
    RENOUNCEMENT_POSSIBLE_DAYS: 30,
    RENOUNCEMENT_AVAIABLE_DAYS: 14,
    INTERVENTION_MNP_IN_STATE_TIME: 5,
};
